export default __webpack_public_path__ + "static/media/pl-file.643f6049.svg";